import { Dialog } from "@remo-co/ui-core/src/components/Dialog";
import { DialogActions } from "@remo-co/ui-core/src/components/DialogActions";
import { DialogContent } from "@remo-co/ui-core/src/components/DialogContent";
import { DialogTitle } from "@remo-co/ui-core/src/components/DialogTitle";
import { Typography } from "@remo-co/ui-core/src/components/Typography";
import { useI18n } from "i18n";
import { useAppDispatch } from "store/hooks";
import { Events, TRACKING_CONTEXT } from "modules/tracking";
import { useContext } from "react";
import {
  selectCurrentEvent,
  selectIsEventManager,
} from "modules/event/selectors";
import { useSelector } from "react-redux";
import { Close as CloseIcon } from "@remo-co/ui-core/src/icons/Close";
import { AudioReactionsContainer } from "../AudioReactionsContainer";
import { useStyles } from "./styles";
import { setAudioReactionDialog } from "../redux/slice";
import { selectOpenReactionDialog } from "../redux/selectors";

export const AudioReactionDialog = () => {
  const audioReactionDialog = useSelector(selectOpenReactionDialog);
  const hasEventManagerAccess = useSelector(selectIsEventManager);
  const { t } = useI18n(["event"]);
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const { track } = useContext(TRACKING_CONTEXT);
  const currentEvent = useSelector(selectCurrentEvent);

  const handleClose = () => {
    dispatch(setAudioReactionDialog(false));
    track(Events.AUDIO_REACTIONS_CANCELLED, {
      eventId: currentEvent?.id,
      eventType: currentEvent?.eventType,
    });
  };

  if (!audioReactionDialog || !hasEventManagerAccess) {
    return null;
  }

  return (
    <Dialog
      PaperProps={{ className: classes.dialogPaper }}
      className={classes.audioReactionDialog}
      open
      data-testid="audio-reaction-dialog"
      onClose={handleClose}
    >
      <DialogTitle>
        <div className={classes.dialogTitle}>
          <Typography className={classes.audioReactionDialogTitle}>
            {t("event:pick.sound.effect.to.play")}
          </Typography>
          <CloseIcon
            className={classes.closeIcon}
            onClick={handleClose}
            data-testid="audio-reactions-close-btn"
          />
        </div>
      </DialogTitle>
      <DialogContent>
        <Typography className={classes.audioReactionDialogContent}>
          {t("event:sound.effects.description")}
        </Typography>
      </DialogContent>
      <DialogActions>
        <AudioReactionsContainer />
      </DialogActions>
    </Dialog>
  );
};
